// extracted by mini-css-extract-plugin
export var formContainer = "_e3-0";
export var message = "_e3-1";